window.globalHelpersModule.directive "confirmedProposalExpired", 
['$rootScope', '$log', '$timeout', '$filter', '$state', 'AuthService', 'toastr',
($rootScope, $log, $timeout, $filter, $state, AuthService, toastr) ->
  restrict: "E"
  scope:
    feedItem: "="
  link: (scope, element, attrs) ->

  templateUrl: 'portal/appointments/feed-items/confirmed_proposal_expired/confirmed_proposal_expired-directive-template.html'
]